const FIGMA_QA_PATHS = new Set(["/figma-qa", "/porownanie"]);

const normalizePathname = (pathname = "") => {
  if (!pathname) return "";
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
};

export const isFigmaQaPath = (pathname = "") =>
  FIGMA_QA_PATHS.has(normalizePathname(pathname));
